export default __webpack_public_path__ + "static/media/techtop-full-logo.c3785e19.svg";